module.exports = __webpack_public_path__ + "img/homeSec03bg4.2732e587.jpg";